import React, { useState } from "react";

type Props = {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  onSubmit: (comment: string) => void;
};

const PendingCommentModal: React.FC<Props> = ({
  isOpen,
  title,
  onClose,
  onSubmit,
}) => {
  const [comment, setComment] = useState("");

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-96 rounded-lg shadow-lg p-5">
        <h3 className="text-lg font-semibold mb-3">{title}</h3>

        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Enter comment..."
          className="w-full border rounded p-2 text-sm"
          rows={4}
        />

        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={onClose}
            className="px-3 py-1 text-sm rounded border"
          >
            Cancel
          </button>

          <button
            disabled={!comment.trim()}
            onClick={() => {
              onSubmit(comment);
              setComment("");
            }}
            className="px-3 py-1 text-sm rounded bg-red-600 text-white disabled:opacity-50"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingCommentModal;
